module.exports = __webpack_public_path__ + "img/DragonKingHotPots.e04ff9ae.png";